module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-dialog', {
    attrs: {
      "title": "选择图片",
      "visible": _vm.dialogFormVisible,
      "top": "141px",
      "before-close": _vm.handleClose,
      "width": "800px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "margin-right": "30px"
    },
    attrs: {
      "id": "cut_container"
    }
  }, [_c('h3', {
    staticClass: "menu"
  }, [_vm._v("裁剪框")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": "80%",
      "margin-bottom": "15px",
      "display": "block",
      "opacity": "0",
      "height": "40px",
      "position": "relative",
      "z-index": "2"
    },
    attrs: {
      "type": "file",
      "id": 'change_btn_' + _vm.uploadId
    },
    on: {
      "change": function($event) {
        return _vm.fileChange($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uploadBody",
    staticStyle: {
      "background-color": "#d6d6d6",
      "height": "320px"
    }
  }, [_c('img', {
    attrs: {
      "id": 'image_' + _vm.uploadId
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('h3', {
    staticClass: "menu"
  }, [_vm._v("裁剪预览框")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "52px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pre-container"
  }, [_c('div', {
    staticClass: "small"
  }), _vm._v(" "), _c('div', {
    staticClass: "cavans"
  })])])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "picUpload mt20"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.upload2()
      }
    }
  }, [_vm._v("发布"), (_vm.percent) ? _c('span') : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-326de1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./~/_xiaozhu@2022.4.8@xiaozhu/vue/components/admin/cropUploadPicNew2.vue
// module id = 245
// module chunks = 49